module.exports = {
  downloadBlob: (blob, filename) => {
    if (!(blob instanceof Blob)) {
      throw new TypeError('downloadBlob: expected Blob, got ' + (blob?.constructor?.name || typeof blob));
    }
    const blobUrl = window.URL.createObjectURL(blob);
    const tempLink = document.createElement('a');
    tempLink.href = blobUrl
    tempLink.setAttribute('download', filename)
    tempLink.click()
  }
}